import React, { useState, useReducer, createContext, useContext, useEffect } from 'react';
import { Select, Button, Table, Modal, Input, DatePicker, Switch, message } from 'antd';
import "./index.less";
import { classifyList, sloganAdd, sloganUpdate, sloganList, sloganStatust, selectSloganList } from "../../api";
const { Option } = Select;
const Ctx = createContext();

const initInfo = {
    firstClassifyChooseName: '',
    secondClassifyChooseName: '',
    firstClassifyChooseId: '',
    secondClassifyChooseId: '',
    caseId: '',
    slogan: '',
    title: ''
}
const reducer = (state, action) => {
    return { ...state, ...action };
}

const recommendStatus = ['启用中', '停用中'];

//  子组件模态框
const EditModal = () => {
    const { state: { isModalVisible, info, isModify }, dispatch } = useContext(Ctx);
    const [selectSloganListData, setSelectSloganListData] = useState([])
    const [showSlogan, setShowSlogan] = useState('')
    const [showEditorSlogan, setShowEditorSlogan] = useState(info.sloganId)

    useEffect(() => {
        // 弹窗打开调取下拉框标语接口
        getSelectSloganList()
    }, [])
    useEffect(() => {
        // 弹窗打开调取下拉框标语接口
        setShowEditorSlogan(info.sloganId)
    }, [info.sloganId])
    const getSelectSloganList = async () => {
        let res;
        res = await selectSloganList()
        if (res?.error?.errorCode == 0) {
            setSelectSloganListData(res?.data)
        }
    }
    const handleOk = async () => {
        if (info.caseId) {
            let res;
            const params = {
                caseId: info.caseId,
                firstClassifyId: info.firstClassifyChooseId,
                secondClassifyId: info.secondClassifyChooseId,
                slogan: '',
                sloganId: isModify ? showSlogan : showEditorSlogan,
                title: info.title
            }

            if (isModify) {
                console.log(showSlogan)
                if (showSlogan != 'undefined' && showSlogan != '') {
                    params.slogan = selectSloganListData.filter(item => item.id == showSlogan)[0].value;
                    res = await sloganAdd({ ...params, title: '' });
                } else {
                    message.error('请选择标语!')
                    return;
                }

            } else {
                if (showEditorSlogan == undefined) {
                    message.error('请选择标语!')
                    return;
                }
                params.slogan = selectSloganListData.filter(item => item.id == showEditorSlogan)[0].value;
                res = await sloganUpdate({ ...params, firstClassifyId: '', secondClassifyId: '' });
            }
            if (res?.error?.errorCode == 0) {
                dispatch({ isModalVisible: false, success: true });
                if (isModify) {
                    message.success('新增成功!');
                } else {
                    message.success('修改成功!');
                }

            } else {
                message.error(res?.error?.errorMsg);
            }
        } else {
            message.error('信息未填写完整!');
        }
    };

    const handleCancel = () => {
        dispatch({ isModalVisible: false });
        setShowSlogan('')
        setShowEditorSlogan(info.sloganId)
    };

    // 新增改变标语
    const handleChangeSelectSlogan = value => {
        setShowSlogan(value)//显示标语
    };
    // 编辑改变标语
    const handleChangeEditorSelectSlogan = value => {
        setShowEditorSlogan(value)//显示标语
    };

    return (
        <Modal visible={isModalVisible} wrapClassName='classify_yunying_modal' onOk={handleOk} onCancel={handleCancel} footer={[
            isModify ? <Button key="submit" type="primary" onClick={handleOk}>
                增加
            </Button> : <Button key="submit" type="primary" onClick={handleOk}>
                修改
            </Button>
        ]}>
            {
                isModify ? (
                    <>
                        <div className='form_item'>
                            <span className='form_item_label'>输入caseID：</span>
                            <Input className='form_item_input' placeholder="请输入caseID" value={info.caseId} onChange={e => dispatch({ info: { ...info, caseId: e.target.value } })} />
                        </div>
                        <div className='form_item'>
                            <span className='form_item_label'>请选择标语：</span>
                            {/* <Input className='form_item_input' placeholder="请输入标语" value={info.sloganId} onChange={e => dispatch({ info: { ...info, slogan: e.target.value } })} /> */}
                            <Select value={showSlogan} style={{ width: 372 }} onChange={handleChangeSelectSlogan}>
                                {
                                    selectSloganListData.length > 0 ? selectSloganListData.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.value}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div className="bottomClassify">
                            <div>
                                <span>一级分类：</span>
                                <span>{info.firstClassifyChooseName}</span>
                            </div>
                            <div>
                                <span>二级分类：</span>
                                <span>{info.secondClassifyChooseName}</span>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className='form_item'>
                            <span className='form_item_label'>case ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;：</span>
                            <span>{info.caseId}</span>
                        </div>
                        <div className='form_item'>
                            <span className='form_item_label'>请选择标语：</span>
                            {/* <Input className='form_item_input' placeholder="请输入标语" value={info.sloganId} onChange={e => dispatch({ info: { ...info, slogan: e.target.value } })} /> */}
                            <Select value={showEditorSlogan} style={{ width: 372 }} onChange={handleChangeEditorSelectSlogan}>
                                {
                                    selectSloganListData.length > 0 ? selectSloganListData.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.value}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div className='form_item'>
                            <span className='form_item_label'>案例名称&nbsp;&nbsp;：</span>
                            <span className='caseTitle'>{info.title}</span>
                        </div>
                    </>
                )
            }

        </Modal>
    )
}
// 父组件 最外层
function ClassifyManage() {
    const [firstClassifyChoose, setfirstClassifyChoose] = useState(1);//一级分类默认选中
    const [secondClassifyChoose, setsecondClassifyChoose] = useState(''); // 二级分类默认选中
    const [listLoading, setListLoading] = useState(false)
    const [firstClassifyList, setFirstClassifyList] = useState([]);
    const [secondClassifyList, setSecondClassifyList] = useState([]);
    const [sloganArr, setSloganArr] = useState([]);
    const [state, dispatch] = useReducer(reducer, {
        isModify: true, isModalVisible: false, info: initInfo, success: false
    });
    useEffect(() => {
        // 获取一级分类列表
        getFirstClassifyList()
        // 获取
    }, [])
    useEffect(() => {
        // 二级分类监听 刷新列表
        if (secondClassifyChoose) {
            getSloganList(0, secondClassifyChoose, '')
        } else {
            setSloganArr([])
        }
    }, [secondClassifyChoose])
    useEffect(() => {
        if (state.success) {
            getSloganList(0, secondClassifyChoose, '');
            dispatch({ success: false })
        }
    }, [state.success]);
    const columns = [
        {
            title: 'CASE_ID',
            dataIndex: 'caseId',
            width: '8%',
        },
        {
            title: '标题',
            dataIndex: 'title',
            width: '20%'
        },
        {
            title: '标语',
            dataIndex: 'slogan',
            width: '12%',
        },
        {
            title: '一级分类',
            dataIndex: 'firstClassifyName',
            width: '12%',
        },
        {
            title: '二级分类',
            dataIndex: 'secondClassifyName',
            width: '12%',
        },
        {
            title: '状态',
            dataIndex: 'delStatus',
            width: '10%',
            // sorter: (a, b) => a.delStatus > b.delStatus ? 1 : -1,
            sorter: true,
            render: (v) => {
                return (
                    <span>{recommendStatus[v]}</span>
                )
            }
        },
        {
            title: '维护时间',
            dataIndex: 'createTime',
            width: '12%',
        },
        {
            title: '操作',
            dataIndex: '',
            render: (v, r) => {
                return (
                    <>
                        {r.delStatus == 0
                            ? <Button onClick={() => updateStatus(r.id, 1)}>停用</Button> : <Button onClick={() => updateStatus(r.id, 0)}>启用</Button>}
                        <Button onClick={() => modify(r)}>编辑</Button>
                    </>
                )
            },
        }
    ]
    // 编辑带入当前列表的数据填充
    const modify = record => {
        dispatch({
            isModalVisible: true, isModify: false,
            info: {
                ...state.info, caseId: record.caseId,
                sloganId: record.sloganId,
                title: record.title
            }
        });
    }
    // 启用，停用接口
    const updateStatus = async (sloganId, status) => {
        const res = await sloganStatust(sloganId, status);
        if (res?.error?.errorCode == 0) {
            getSloganList(0, secondClassifyChoose, '');
        }
    }

    // 获取标语列表 渲染表格
    const getSloganList = (orderType, secondClassifyId, caseId) => {
        setListLoading(true)
        sloganList(orderType, secondClassifyId, caseId).then((res) => {
            if (res?.error?.errorCode == 0) {
                if (res?.data.length > 0) {
                    setSloganArr(res?.data)
                } else {
                    setSloganArr([])
                    // message.error('暂无数据')
                }

            }
        }).finally(() => {
            setListLoading(false)
        })
    }
    // 点击箭头怕排序 重新调取接口
    const sortList = async (orderType, secondClassifyChooseId, caseId) => {
        setListLoading(true)
        const res = await sloganList(orderType, secondClassifyChooseId, caseId)
        if (res?.error?.errorCode == 0) {
            setListLoading(false)
            return res.data
        }
    }
    // 获取一级分类下拉框数据
    const getFirstClassifyList = () => {

        classifyList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    setFirstClassifyList(res?.data)
                    setSecondClassifyList(res?.data[0].secondClassifies)
                    setfirstClassifyChoose(res?.data[0].id)
                    setsecondClassifyChoose(res?.data[0].secondClassifies[0].id)
                    dispatch({ info: { ...state.info, firstClassifyChooseName: res?.data[0].name, secondClassifyChooseName: res?.data[0].secondClassifies[0].name, firstClassifyChooseId: res?.data[0].id, secondClassifyChooseId: res?.data[0].secondClassifies[0].id } });

                }
            })
            .finally(() => {
                setListLoading(false)
            })
    }
    // 一级分类change
    const handleChangeFirstClassify = value => {
        setfirstClassifyChoose(value);
        let secondClassifyList = firstClassifyList.filter(item => item.id == value)
        setSecondClassifyList(secondClassifyList[0].secondClassifies)//存储当前二级分类数据
        setsecondClassifyChoose('')
        dispatch({ info: { ...state.info, firstClassifyChooseName: secondClassifyList[0].name, firstClassifyChooseId: value, secondClassifyChooseName: '', secondClassifyChooseId: '' } });

    };
    // 二级分类change
    const handleChangeSecondClassify = value => {
        setsecondClassifyChoose(value);
        let filterNameArr = secondClassifyList.filter(item => item.id == value)
        dispatch({ info: { ...state.info, secondClassifyChooseName: filterNameArr[0].name, secondClassifyChooseId: value } });
    };

    const search = () => {
        if (secondClassifyChoose) {
            getSloganList(0, secondClassifyChoose, '')
        } else {
            message.error('请选择二级分类');
        }
    }

    const addNewItem = () => {
        if (secondClassifyChoose) {
            getSloganList(0, secondClassifyChoose, '')
            dispatch({ isModalVisible: true, isModify: true, info: { ...state.info, caseId: '', slogan: '' } });
        } else {
            message.error('请选择二级分类')
        }

    }

    const changetable = (pagination, filters, sorter) => {
        console.log(sorter)
        if (sorter.order) {
            if (sorter.order == "ascend") {
                getSloganList(0, secondClassifyChoose, '')
            } else {
                getSloganList(1, secondClassifyChoose, '')
            }
        } else {
            getSloganList(0, secondClassifyChoose, '')
        }

    }
    return (
        <div className="classifyManage">
            <div className="topForm">
                <h2>案例分类运营</h2>
                <div className="myForm">
                    <div>
                        <span className="select_label">一级分类：</span>
                        <Select value={firstClassifyChoose} style={{ width: 120 }} onChange={handleChangeFirstClassify}>
                            {
                                firstClassifyList.length > 0 ? firstClassifyList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        <span className="select_label">二级分类：</span>
                        <Select value={secondClassifyChoose} style={{ width: 120 }} onChange={handleChangeSecondClassify}>
                            {
                                secondClassifyList.length > 0 ? secondClassifyList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        {/* <Button type="primary" onClick={search}>查询</Button> */}
                        <Button type="primary" onClick={addNewItem}>新增</Button>
                    </div>
                </div>

            </div>
            <div className="bottomTable">
                <Table
                    loading={listLoading}
                    columns={columns}
                    dataSource={sloganArr}
                    pagination={false}
                    onChange={(pagination, filters, sorter) => { changetable(pagination, filters, sorter) }}
                />
            </div>
            <Ctx.Provider value={{ state, dispatch }} >
                <EditModal isModalVisible={state.isModalVisible} />
            </Ctx.Provider>
        </div >
    )
}

export default ClassifyManage;